import React from "react";
import PropTypes from "prop-types";
import {makeStyles, Box, Typography} from "@material-ui/core";
import defaultTheme from "../../../common/theme";

const useStyles = makeStyles(theme => ({
    backgroundSecondary: {
        background: theme.palette.secondary[100]
    }
}));

const ActionCard = ({
    image,
    title,
    description,
    cta,
    ...props
}) => {
    const classes = useStyles();

    return (
        <Box
            border={1}
            borderRadius={8}
            borderColor={defaultTheme.palette.borders.line.lighter}
            overflow="hidden"
            height="100%"
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            maxWidth="348px"
            {...props}
        >
            <Box
                textAlign="center"
            >
                <Box
                    mt={3}
                >
                    <img
                        src={image}
                        alt={title}
                    />
                </Box>

                <Box
                    mt={3}
                    pr={2}
                    pl={2}
                >
                    <Typography
                        variant={"h4"}
                    >
                        {title}
                    </Typography>
                </Box>
                {description}
            </Box>
            <Box
                mt={3}
                px={3.75}
                py={2}
                className={classes.backgroundSecondary}
            >
                {cta}
            </Box>
        </Box>
    );
};

ActionCard.propTypes = {
    image: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.any,
    cta: PropTypes.element
};

export default ActionCard;
